import { render, staticRenderFns } from "./AssetCardList.vue?vue&type=template&id=cdf1fd78"
import script from "./AssetCardList.vue?vue&type=script&lang=js"
export * from "./AssetCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdf1fd78')) {
      api.createRecord('cdf1fd78', component.options)
    } else {
      api.reload('cdf1fd78', component.options)
    }
    module.hot.accept("./AssetCardList.vue?vue&type=template&id=cdf1fd78", function () {
      api.rerender('cdf1fd78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/fixed-asset/AssetCardList.vue"
export default component.exports